import { authenticatedFetch } from '../../../api/utils/request';

export default async function getAppointmentHistoryById(appointmentId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener el historial de la cita');
    return await authenticatedFetch(`/appointment-management/history/${appointmentId}`, onError);
}
